import { createFileRoute } from "@tanstack/react-router"
import { EmployerTeamPanel } from "@/components/settings/employer-team-panel"

export const Route = createFileRoute("/recruit/settings/team")({
  component: EmployerTeamSettings,
})

function EmployerTeamSettings() {
  return <EmployerTeamPanel />
}
